let instances = [];

class CheckboxToggle {
    /**
     * Binding our event listener to the checkbox.
     *
     * @param {HTMLElement} element
     */
    constructor(element) {
        this.element = element;
        this.checkbox = this.element.querySelector("input[type=checkbox]");

        this.bindEvents();
    }

    /**
     * Adds on change event listener.
     *
     * @return {void}
     */
    bindEvents() {
        this.checkbox.addEventListener("change", (event) => {
            if (event.target.checked === true) {
                this.element.classList.add("active");
            } else {
                this.element.classList.remove("active");
            }
        });
    }
}

export default {
    init: (element) => {
        instances.push(new CheckboxToggle(element));
    },

    destroy: () => {
        instances.forEach((instance) => instance.unbindEvents());
        instances = [];
    },
};
